import React from 'react'
import { useEffect } from 'react'

const ShipAniTrackMap = (props) => {
    const getPath = () => {
        let path = []
        console.log(props.events, 'events')
        props.events.map((e) => {
            if (Object.keys(e).includes("lat")) {
                path.push({ lng: e.lon, lat: e.lat })
            }
            return ""
        });
        return path
    }

    const getCenter = (path) => {
        var centerLat = 0, centerLon = 0
        for (var i = 0; i < path.length; i++) {
            centerLat += path[i].lat
            centerLon += path[i].lng
        }
        centerLat = centerLat / path.length
        centerLon = centerLon / path.length
        return { lng: centerLon, lat: centerLat };
    }

    const BMapGL = window.BMapGL
    const BMapGLLib = window.BMapGLLib

    useEffect(() => {
        initMap()
    }, [props.events])

    const initMap = () => {
        let bmap = new BMapGL.Map("anitrack");                          // 创建Map实例
        const center = getCenter(getPath())
        bmap.centerAndZoom(new BMapGL.Point(center.lng, center.lat), 17);    // 初始化地图，设置中心点坐标和地图级别
        bmap.enableScrollWheelZoom(true);                             // 开启鼠标滚轮缩放
        const path = getPath()
        let point = [];
        for (let i = 0; i < path.length; i++) {
            point.push(new BMapGL.Point(path[i].lng, path[i].lat));
        }
        let pl = new BMapGL.Polyline(point);
        function start() {
            let trackAni = new BMapGLLib.TrackAnimation(bmap, pl, {
                overallView: true, // 动画完成后自动调整视野到总览
                tilt: 50,          // 轨迹播放的角度，默认为55
                duration: 30000,   // 动画持续时长，默认为10000，单位ms
                delay: 3000        // 动画开始的延迟，默认0，单位ms
            });
            trackAni.start();
        }
        setTimeout(start, 3000);
    }

    return (
        <div style={{ width: '65vw', height: '60vh' }}>
            <div id="anitrack" style={{width:'100%', height:'100%'}}></div>
        </div>
    )
}

export default ShipAniTrackMap